<!-- 로그인 다이얼로그 컨테이너 -->
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <!-- 다이얼로그 헤더 -->
    <div class="modal-header">
      <h1 class="modal-title fs-5">{{ 'login' | translate }}</h1>
      <button type="button" class="btn-close" (click)="close(false)"></button>
    </div>

    <!-- 로그인 폼 -->
    <form class="root-form" [formGroup]="loginForm" (submit)="onLoginClick()">
      <div class="modal-body">
        <!-- 로고 섹션 -->
        <div class="title-wrapper">
          <!-- <img
          class="login-lock-img"
          src="/assets/imgs/login-lock.png"
        srcset="
          /assets/imgs/login-lock@2x.png 2x,
          /assets/imgs/login-lock@3x.png 3x
        "
          /> -->
          <span class="title"
            ><img
            class="company-logo"
            [src]="homepageLogoImageUrl"
            alt="Company Logo"
          /></span>
        </div>

        <!-- 로그인 입력 필드 섹션 -->
        <div class="login-container">
          <!-- 아이디 입력 필드 -->
          <trnty-input-wrapper>
            <input
              type="text"
              autocomplete="username"
              [placeholder]="'Id' | translate"
              formControlName="id"
              (keydown)="onInputKeydown($event)"
              (input)="onInput($event)"
              [disabled]="isLoggingIn"
              />
            <span error>{{ 'VALID.id' | translate }}</span>
          </trnty-input-wrapper>

          <!-- 비밀번호 입력 필드 -->
          <trnty-input-wrapper>
            <input
              [type]="isPasswordVisible ? 'text' : 'password'"
              autocomplete="current-password"
              formControlName="pw"
              [placeholder]="'Password' | translate"
              (keydown)="onInputKeydown($event)"
              (input)="onInput($event)"
              [disabled]="isLoggingIn"
              />
            <!-- 비밀번호 표시/숨김 토글 버튼 -->
            <button
              type="button"
              class="btn btn-outline-dark pw-visibility"
              (click)="isPasswordVisible = !isPasswordVisible"
              [attr.aria-label]="
                isPasswordVisible ? '비밀번호 숨기기' : '비밀번호 보기'
              "
              [disabled]="isLoggingIn"
              >
              <i
                class="bi bi-eye{{ isPasswordVisible ? '' : '-slash' }}-fill"
              ></i>
            </button>
            <span error>{{ 'inputPw' | translate }}</span>
          </trnty-input-wrapper>
        </div>

        <!-- 로그인 안내문 섹션 -->
        @if (loginPageContent) {
          <p
            class="login-guide text-body-secondary pt-2 ps-2"
            >
            <small [innerText]="loginPageContent"></small>
          </p>
        }
      </div>

      <!-- 다이얼로그 푸터 -->
      <div class="modal-footer center">
        <!-- 로그인 버튼 -->
        <button
          type="submit"
          class="btn btn-primary login-button"
          trnty-button
          [disabled]="isLoggingIn"
          >
          @if (!isLoggingIn) {
            <span>{{ 'login' | translate }}</span>
          }
          @if (isLoggingIn) {
            <span>
              <i class="bi bi-arrow-repeat spin me-2"></i>
              {{ 'Logging in...' | translate }}
            </span>
          }
        </button>

        <!-- 추가 옵션 섹션 -->
        <div class="option-wrapper">
          <div class="checkbox-wrapper">
            <!-- 로그인 상태 유지 체크박스 (현재 비활성화) -->
          </div>
          <div class="sub-button-wrapper">
            <!-- 계정 정보 찾기 링크 -->
            <a
              class="find-button"
              (click)="onFindInfoClick()"
              [class.disabled]="isLoggingIn"
              >
              {{ 'Find Info' | translate }}
            </a>
            <span>|</span>
            <!-- 회원가입 링크 -->
            <a
              class="join-button"
              (click)="onJoinClick()"
              [class.disabled]="isLoggingIn"
              >
              {{ 'join' | translate }}
            </a>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
